import "./css/output.css";
export default function ListValue({
  label,
  value,
  labelAttr,
  ordered,
  className,
  ...props
}) {
  const items = value.map((item, index) => {
    if (item instanceof Object) {
      return (
        <li key={index}>
          {(labelAttr instanceof Function && labelAttr(item)) ||
            item[labelAttr]}
        </li>
      );
    } else {
      return (
        <li key={index}>{labelAttr instanceof Function && labelAttr(item)}</li>
      );
    }
  });
  const computedClassName = ["output", "list-value", ...className.split(" ")]
    .join(" ")
    .trim();
  return (
    <div className={computedClassName} {...props}>
      {!!label && <strong>{label}</strong>}
      {!!ordered && <ol>{items}</ol>}
      {!ordered && <ul>{items}</ul>}
    </div>
  );
}

ListValue.defaultProps = {
  className: "",
};
